import React from 'react';
import CustomerSelector from './CustomerSelector';
import InPostPointSelector from './InPostPointSelector';

const inputStyle = {
  width: '100%',
  padding: '6px 10px',
  fontSize: '12px',
  border: '1px solid var(--border)',
  borderRadius: '6px',
  backgroundColor: 'var(--card-bg)',
  color: 'var(--text)',
  outline: 'none'
};

const sectionStyle = {
  backgroundColor: 'var(--card-bg)',
  borderRadius: '8px',
  padding: '1rem',
  marginBottom: '1rem',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
};

const buttonStyle = {
  padding: '6px 12px',
  fontSize: '12px',
  fontWeight: '500',
  display: 'flex',
  alignItems: 'center',
  gap: '0.35rem'
};

const SERVICE_TYPES = [
  { id: 'inpost_locker_standard', label: 'Paczkomat -> Paczkomat', desc: 'Nadanie i odbiór w paczkomacie' },
  { id: 'inpost_locker_to_address', label: 'Paczkomat -> Kurier', desc: 'Nadanie w paczkomacie, kurier dostarcza na adres' },
  { id: 'inpost_courier_locker', label: 'Kurier -> Paczkomat', desc: 'Kurier odbiera, odbiór w paczkomacie' },
  { id: 'inpost_courier_standard', label: 'Kurier -> Adres', desc: 'Kurier odbiera i dostarcza pod adres' }
];

const PARCEL_SIZES = [
  { id: 'small', label: 'A (maly)', dim: '8x38x64 cm' },
  { id: 'medium', label: 'B (sredni)', dim: '19x38x64 cm' },
  { id: 'large', label: 'C (duzy)', dim: '41x38x64 cm' }
];

const NewShipmentForm = ({
  selectedCustomer, setSelectedCustomer,
  serviceType, setServiceType,
  targetPoint, setTargetPoint,
  dropoffPoint, setDropoffPoint,
  parcelSize, setParcelSize,
  comment, setComment,
  codEnabled, setCodEnabled,
  codAmount, setCodAmount,
  insuranceEnabled, setInsuranceEnabled,
  insuranceAmount, setInsuranceAmount,
  creating, createError, createSuccess,
  onCreateShipment,
}) => {
  return (
    <div>
      {createError && (
        <div style={{ padding: '0.5rem', backgroundColor: 'var(--danger-light)', color: 'var(--danger)', borderRadius: '4px', marginBottom: '1rem', fontSize: '11px' }}>
          {createError}
        </div>
      )}
      {createSuccess && (
        <div style={{ padding: '0.5rem', backgroundColor: 'var(--success-light)', color: 'var(--success)', borderRadius: '4px', marginBottom: '1rem', fontSize: '11px' }}>
          {createSuccess}
        </div>
      )}

      {/* Typ wysylki */}
      <div style={sectionStyle}>
        <h6 style={{ margin: '0 0 0.75rem', fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          1. Typ wysylki
        </h6>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.5rem' }}>
          {SERVICE_TYPES.map(service => (
            <div
              key={service.id}
              onClick={() => setServiceType(service.id)}
              style={{
                padding: '0.75rem',
                border: serviceType === service.id ? '2px solid var(--info)' : '1px solid var(--border)',
                borderRadius: '8px',
                cursor: 'pointer',
                backgroundColor: serviceType === service.id ? 'var(--info-light)' : 'var(--card-bg)'
              }}
            >
              <div style={{ fontWeight: '600', fontSize: '12px' }}>{service.label}</div>
              <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '2px' }}>{service.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Klient */}
      <div style={sectionStyle}>
        <h6 style={{ margin: '0 0 0.75rem', fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          2. Wybierz klienta{' '}
          {(serviceType === 'inpost_locker_to_address' || serviceType === 'inpost_courier_standard') && '(kurier dostarcza na jego adres)'}
        </h6>
        <CustomerSelector
          selectedCustomer={selectedCustomer}
          onSelect={setSelectedCustomer}
          onClear={() => setSelectedCustomer(null)}
        />
        {(serviceType === 'inpost_locker_to_address' || serviceType === 'inpost_courier_standard') && selectedCustomer && (
          <div style={{ marginTop: '0.5rem', padding: '0.5rem', backgroundColor: 'var(--info-light)', borderRadius: '4px', fontSize: '11px' }}>
            Adres dostawy:{' '}
            {selectedCustomer.wysylka_ulica || selectedCustomer.adres || (
              <span style={{ color: 'var(--danger)' }}>BRAK - uzupelnij dane klienta!</span>
            )}, {selectedCustomer.wysylka_miasto || selectedCustomer.miasto || ''}{' '}
            {selectedCustomer.wysylka_kod_pocztowy || selectedCustomer.kod_pocztowy || ''}
          </div>
        )}
      </div>

      {/* Paczkomat docelowy (Paczkomat->Paczkomat i Kurier->Paczkomat) */}
      {(serviceType === 'inpost_locker_standard' || serviceType === 'inpost_courier_locker') && (
        <div style={sectionStyle}>
          <h6 style={{ margin: '0 0 0.75rem', fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)' }}>
            3. Paczkomat docelowy (odbior przez klienta)
          </h6>
          <InPostPointSelector
            selectedPoint={targetPoint}
            onSelect={setTargetPoint}
            onClear={() => setTargetPoint(null)}
            label="Wybierz paczkomat docelowy"
          />
        </div>
      )}

      {/* Paczkomat nadawczy (Paczkomat->Kurier) */}
      {serviceType === 'inpost_locker_to_address' && (
        <div style={sectionStyle}>
          <h6 style={{ margin: '0 0 0.75rem', fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)' }}>
            3. Paczkomat nadawczy (gdzie wrzucisz paczke)
          </h6>
          <InPostPointSelector
            selectedPoint={dropoffPoint}
            onSelect={setDropoffPoint}
            onClear={() => setDropoffPoint(null)}
            label="Wybierz paczkomat nadawczy"
          />
        </div>
      )}

      {/* Rozmiar paczki */}
      <div style={sectionStyle}>
        <h6 style={{ margin: '0 0 0.75rem', fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          4. Rozmiar paczki
        </h6>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {PARCEL_SIZES.map(size => (
            <div
              key={size.id}
              onClick={() => setParcelSize(size.id)}
              style={{
                flex: 1,
                padding: '0.75rem',
                textAlign: 'center',
                border: parcelSize === size.id ? '2px solid var(--success)' : '1px solid var(--border)',
                borderRadius: '8px',
                cursor: 'pointer',
                backgroundColor: parcelSize === size.id ? 'var(--success-light)' : 'var(--card-bg)'
              }}
            >
              <div style={{ fontWeight: '600', fontSize: '12px' }}>{size.label}</div>
              <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{size.dim}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Opcje dodatkowe */}
      <div style={sectionStyle}>
        <h6 style={{ margin: '0 0 0.75rem', fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          Opcje dodatkowe
        </h6>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          {/* COD */}
          <div style={{ flex: 1, minWidth: '200px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', marginBottom: '0.5rem' }}>
              <input type="checkbox" checked={codEnabled} onChange={(e) => setCodEnabled(e.target.checked)} style={{ width: '16px', height: '16px' }} />
              <span style={{ fontSize: '12px', fontWeight: '500' }}>Pobranie (COD)</span>
            </label>
            {codEnabled && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input
                  type="number" value={codAmount} onChange={(e) => setCodAmount(e.target.value)}
                  placeholder="Kwota" min="0" step="0.01"
                  style={{ ...inputStyle, width: '120px' }}
                />
                <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>PLN</span>
              </div>
            )}
          </div>

          {/* Ubezpieczenie */}
          <div style={{ flex: 1, minWidth: '200px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', marginBottom: '0.5rem' }}>
              <input type="checkbox" checked={insuranceEnabled} onChange={(e) => setInsuranceEnabled(e.target.checked)} style={{ width: '16px', height: '16px' }} />
              <span style={{ fontSize: '12px', fontWeight: '500' }}>Ubezpieczenie</span>
            </label>
            {insuranceEnabled && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input
                  type="number" value={insuranceAmount} onChange={(e) => setInsuranceAmount(e.target.value)}
                  placeholder="Wartosc" min="0" step="0.01"
                  style={{ ...inputStyle, width: '120px' }}
                />
                <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>PLN</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Komentarz */}
      <div style={sectionStyle}>
        <h6 style={{ margin: '0 0 0.75rem', fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          Komentarz (opcjonalnie)
        </h6>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Dodatkowe informacje dla kuriera..."
          style={{ ...inputStyle, minHeight: '60px', resize: 'vertical' }}
        />
      </div>

      {/* Przycisk tworzenia */}
      <div style={{ textAlign: 'right' }}>
        <button
          onClick={onCreateShipment}
          disabled={creating || !selectedCustomer}
          style={{
            ...buttonStyle,
            backgroundColor: creating ? 'var(--text-muted)' : 'var(--success)',
            color: '#fff' ,
            fontWeight: '600'
          }}
        >
          {creating ? 'Tworzenie...' : 'Utworz przesylke'}
        </button>
      </div>
    </div>
  );
};

export default NewShipmentForm;
